export const MATTER_TASK_PLAN_TASK_TRIGGER_TYPE_OPTIONS = [
  "taskCompletion",
  "matterStatus",
  "actionTaken",
] as const;
